module.exports = __webpack_public_path__ + "static/media/nir.eef9ebe8.svg";